import { getDatasWithOption } from '../../utils/service';
import { BREAKPOINTS } from '../../model/model';
import { isChrome, isDefined, isObject, not, isNotDefined, each, truthy, falsy, parseInt10, isMobileResolution, getResolution } from '../../utils/util';
import SettingModel from './tpl';

class BeginnerHunt {
    constructor(options) {
        const _ = this;

        if (!options) return;

        _.option = $.extend({
        wrap: null,
        apiDomain: '',
        classId: 0,
        level: 1,
        isLogin: false,
        global: window
        }, options);

        _.model = new SettingModel;
        _.global = (_.option.global) ? _.option.global : window;

    }

/*  init() {
      const _ = this
      console.log('BeginnerHunt init !! ');

    _.setData();

  }*/
    init() {
        const _ = this,
            _wrap = _.option.wrap.huntWrap;
        console.log('# BeginnerHunt init !! ');

        getDatasWithOption([{
            type: 'GET',
            url: _.option.apiDomain +'/conti/getContent?service=lineage&alias=beginner-hunt&lang=ko-KR',
            dataType: 'json',
            contentType: 'application/json',
            Accept: 'application/json'
        }], (data) => {
            console.log('# BeginnerRecommend.js data : ', JSON.parse(data.jsonData) );
            if(data.jsonData.length <= 0) {
                _.setNoData();
            } else {
                _.setData(JSON.parse(data.jsonData));
            }
        }, (data) => {
            console.log('데이터를 불러올 수 없습니다. 잠시 후, 다시 시도해주세요.');
        });
    }

    setNoData() {
        $(this.option.wrap.recommendWrap).empty().append(`<div class="nodata"> - </div>`);
    }

  setData(data) {
    const _ = this,
        _level = _.option.level,
        _classId = _.option.classId,
        // _data = _.global.huntData.groups,
        _wrap = _.option.wrap.huntWrap;


      _.setInstance(data.groups);


      /*let _lv;
      if( 80 <= _level ) {
          _lv = 4;
      } else if ( 75 <= _level && _level < 80 ) {
          _lv = 3;
      } else if ( 55 <= _level && _level < 75 ) {
          _lv = 2;
      } else {
          _lv = 1;
      }*/
      let _lv = 1;

      $('.tab li', _wrap).removeClass('on');
      $('.table' , _wrap).hide();

      $('.tab li:nth-child('+ _lv +')', _wrap).addClass('on');
      $('#hunt-'+ _lv , _wrap).show();


      $('.tab a', _wrap).on('click', function(){
          let _lv = $(this).data('lv');

          $('.tab li', _wrap).removeClass('on');
          $('.table' , _wrap).hide();

          $('.tab li:nth-child('+ _lv +')', _wrap).addClass('on');
          $('#hunt-'+ _lv , _wrap).show();
          return false;
      });

      // _.setActive(_lv);

  }


  setInstance(data){
    const _ = this,
        _level = _.option.level,
        _classId = _.option.classId,
        _wrap = _.option.wrap.huntWrap;

    let tpl = '';

    console.log('setInstance() data : ', data);

    data.map( (groups, groupsIndex) => {
        const group = groups.items;
        let _idx = groupsIndex +1;

        tpl += `
            <table class="table table-size-${group.length}" id="hunt-${_idx}">
                <thead>
                    <tr>
                        <th class="name thead"><span>사냥터</span></th>`;


        group.map( (item, itemIndex) => {
            tpl += `<th class="name"><a href="${item.url}">${item.name}</a></th>`;
        });
        tpl += `</tr>
            </thead>
            <tbody>
                <tr>
                    <td class="limit thead"><span>입장 조건</span></td>`;
        group.map( (item, itemIndex) => {
            tpl += `<td class="limit">${item.limit}</td>`;
        });
        tpl += `</tr>
				<tr>
                    <td class="zone thead"><span>지역 설정</span></td>`;
        group.map( (item, itemIndex) => {
            tpl += `<td class="zone">${item.zone}</td>`;
        });
        tpl += `</tr>
				<tr>
                    <td class="feature thead"><span>주요 특징</span></td>`;
        group.map( (item, itemIndex) => {
            tpl += `<td class="feature">${item.feature}</td>`;
        });

        tpl += `</tr>
            </tbody>
        </table>`;
    });

    let tmpl_tab = `
    <ul class="tab">
    ${data.map( (item, i) => {
      return `<li><a href="" data-lv="${i+1}">${item.title}</a></li>`;
    }).join('')}
    </ul>
    `;

      $('.article-tab', _wrap).empty().append(tmpl_tab); // tab
      $('.table-bundle-row', _wrap).empty().append(tpl);


  } // setInstance()



}

export default BeginnerHunt;


// WEBPACK FOOTER //
// ./_src/js/service/beginner/BeginnerHunt.js